module.exports = __webpack_public_path__ + "static/media/coffetable222.50917bf3.png";